var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 120,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.2 96.4 1.3 1.4-.4 11.5-50.4 10.1a2.9 2.9 0 0 1-3-1.2l-.4-1L.6 43.6A2.9 2.9 0 0 1 3 40.2l53.6-10.7-2.3 8.2 5.1 9.4-4 17L67 75.7l-3.7 14.8 5 5.9Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 77.8 19 86.1l-.2.3 1.2 6.2s.2.2.3.1L62 84.4s.2-.2.1-.3L60.8 78c0-.1-.1-.2-.3-.2ZM63.3 90.5l5 5.9-44.4 8.8a1.4 1.4 0 0 1-1.6-1l-.8-3.9a1.4 1.4 0 0 1 1.1-1.7l40.7-8.1Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 30.6 134 103a2.9 2.9 0 0 1-3.6 2L73.2 89.7l6.2-9.4-.7-2.4-2.2-7.6 10.2-11.2L81 42.5l11.2-13-.5-11.8 6.2-5L151.3 27a2.9 2.9 0 0 1 2 3.6Z",
    fill: "#BFBFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m140.7 31.7-10.4-2.8c-2.5-.7-5 .8-5.7 3.3l-2.8 10.4c-.7 2.5.8 5 3.3 5.7l10.4 2.8c2.5.7 5-.8 5.8-3.3l2.7-10.4c.7-2.5-.8-5-3.3-5.7ZM88.3 75l-1 3.7a1.4 1.4 0 0 1-1.8 1l-6.8-1.8-2.2-7.6 10.8 2.9a1.4 1.4 0 0 1 1 1.8Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25a1.6 1.6 0 0 1 0-2.2L76.6 12c.7-.6 1.7-.6 2.3 0l.8.9c.6.6.6 1.6-.1 2.2L68 25a1.6 1.6 0 0 1-2.1 0ZM59.7 21.3a1 1 0 0 1-.5-1.4l4-9a1 1 0 0 1 1.4-.6l.7.3a1 1 0 0 1 .5 1.4L61 20.8a1 1 0 0 1-1.4.5ZM53.1 22.7c-.8.2-1.6-.5-1.8-1.6L48 2.6c-.2-1.2.4-2.2 1.3-2.4l1.2-.2c.9-.1 1.7.7 1.8 1.8l2 18.8c.1 1-.5 2-1.3 2.1Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletEmpty);
export default __webpack_public_path__ + "static/media/walletEmpty.1e21df3da72c649528bf4e3240ccb492.svg";
export { ForwardRef as ReactComponent };